export default __webpack_public_path__ + "static/media/gallery-wip-emitter_13.e886ab39.jpg";